import { useMemo } from 'react';
import { useMovableInkIntegrationContext } from '../../../contexts/MovableInkIntegrationContext';

export const CAMPAIGN_SELECTOR_WITH_SINGLE_INTEGRATION_THRESHOLD = 0;
export const CAMPAIGN_SELECTOR_WITH_MULTIPLE_INTEGRATIONS_STICKY_THRESHOLD = 88;
export const CAMPAIGN_SELECTOR_WITH_CHILD_INTEGRATIONS_STICKY_THRESHOLD = 152;

export const useCampaignSelectorStickyThreshold = () => {
  const { integrations, childIntegrations } = useMovableInkIntegrationContext();

  return useMemo(() => {
    if (childIntegrations.length > 1) {
      return CAMPAIGN_SELECTOR_WITH_CHILD_INTEGRATIONS_STICKY_THRESHOLD; // child integrations
    } else if (integrations.length > 1) {
      return CAMPAIGN_SELECTOR_WITH_MULTIPLE_INTEGRATIONS_STICKY_THRESHOLD; // multiple integrations
    }
    return CAMPAIGN_SELECTOR_WITH_SINGLE_INTEGRATION_THRESHOLD; // single integration
  }, [integrations, childIntegrations]);
};
